import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { completeOidcLogin, getOidcConfig } from '../services/oidcService';

const OIDC_CALLBACK_PROCESSING_KEY = 'cqi_oidc_callback_processing';

const OidcCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string>('Completing sign in...');
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const config = getOidcConfig();
    if (!config) {
      setError('OIDC is not configured. Please contact your administrator.');
      return;
    }

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(`Sign in failed: ${errorDescription || errorParam}`);
      return;
    }

    if (!code || !state) {
      setError('Invalid callback: missing authorization code or state.');
      return;
    }

    // Guard against React Strict Mode double-invocation and accidental refreshes.
    // sessionStorage persists across remounts in the same tab/origin.
    if (sessionStorage.getItem(OIDC_CALLBACK_PROCESSING_KEY)) {
      return;
    }

    sessionStorage.setItem(OIDC_CALLBACK_PROCESSING_KEY, 'true');

    const handleCallback = async () => {
      try {
        await completeOidcLogin(code, state);
        sessionStorage.removeItem(OIDC_CALLBACK_PROCESSING_KEY);
        setStatus('Sign in successful. Redirecting...');
        navigate('/dashboard', { replace: true });
      } catch (err: any) {
        console.error('OIDC callback error:', err);
        sessionStorage.removeItem(OIDC_CALLBACK_PROCESSING_KEY);
        setError(err.response?.data?.message || err.message || 'Sign in failed. Please try again.');
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h2>CQI Dashboard</h2>
          <h3>CHW Registry Sign In</h3>
        </div>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          {error ? (
            <div>
              <div className="error-message">{error}</div>
              <button
                className="login-button"
                style={{ marginTop: '1rem' }}
                onClick={() => navigate('/login')}
              >
                Back to Sign In
              </button>
            </div>
          ) : (
            <div>{status}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OidcCallback;
